var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gd-read"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"gd-read-value",class:{'text-gray': _vm.empty}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }